import { render, staticRenderFns } from "./leave-details.vue?vue&type=template&id=c4fd52be&scoped=true&"
import script from "./leave-details.vue?vue&type=script&lang=js&"
export * from "./leave-details.vue?vue&type=script&lang=js&"
import style0 from "./leave-details.vue?vue&type=style&index=0&id=c4fd52be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fd52be",
  null
  
)

export default component.exports